module.exports = __webpack_public_path__ + "static/img/2e.f46d328.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/2e.jpg
// module id = MZ3/
// module chunks = 0